import { cn } from '@savvy-kit/lib/utils';

import { Skeleton } from './skeleton';

type TableSkeletonProps = {
  /** Number of skeleton rows to render */
  readonly rows?: number;
  /** Number of columns per row */
  readonly columns?: number;
  readonly className?: string;
};

function TableSkeletonRow({ columns }: { readonly columns: number }) {
  return (
    <tr className="border-b border-light">
      {Array.from({ length: columns }).map((_, i) => (
        <td key={i} className="p-2 h-[52px] align-middle">
          <Skeleton className={cn('h-4', i === 0 ? 'w-32' : 'w-20')} />
        </td>
      ))}
    </tr>
  );
}

/** Standalone skeleton table — use when there's no parent <Table> wrapper */
function TableSkeleton({ rows = 5, columns = 4, className }: TableSkeletonProps) {
  return (
    <div className={cn('w-full', className)}>
      <table className="w-full">
        <tbody>
          {Array.from({ length: rows }).map((_, i) => (
            <TableSkeletonRow key={i} columns={columns} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** Skeleton <tbody> — use inside an existing <Table> that already has headers */
function TableBodySkeleton({ rows = 5, columns = 4 }: Omit<TableSkeletonProps, 'className'>) {
  return (
    <tbody>
      {Array.from({ length: rows }).map((_, i) => (
        <TableSkeletonRow key={i} columns={columns} />
      ))}
    </tbody>
  );
}

export { TableBodySkeleton, TableSkeleton };
export type { TableSkeletonProps };
